<router-outlet></router-outlet>

<!-- Global Timeout Warning Popup -->
<ng-template #warningPopup let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Session Timeout Warning</h4>
    </div>
    <div class="modal-body">
      <p>You will be logged out in <strong>{{ timeoutCounter }}</strong> seconds.</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-success" (click)="stayLoggedIn()">Stay Logged In</button>
      <button class="btn btn-danger" (click)="logoutUser()">Logout</button>
    </div>
  </ng-template>
  